"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const embla_carousel_1 = __importDefault(require("embla-carousel"));
const embla_carousel_autoplay_1 = __importDefault(require("embla-carousel-autoplay"));
class HeaderCarousel extends HTMLDivElement {
    constructor() {
        super();
        this.embla = (0, embla_carousel_1.default)(this, {
            loop: true,
            watchDrag: false,
        }, [
            (0, embla_carousel_autoplay_1.default)(),
        ]);
    }
}
exports.default = HeaderCarousel;
